/**
 * @generated SignedSource<<971effaf1557703506f1c5a67a4e77cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type homeHeroArticleContentItemContent$data = {
  readonly entityId: string;
  readonly moreOnThisArticles: ReadonlyArray<{
    readonly entityId: string;
    readonly urlAlias: string;
    readonly " $fragmentSpreads": FragmentRefs<"contentHeadlineContent" | "entityLink">;
  } | null | undefined> | null | undefined;
  readonly topics: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"followButtonBase">;
  } | null | undefined> | null | undefined;
  readonly urlAlias: string;
  readonly " $fragmentSpreads": FragmentRefs<"contentTopicLinkContent" | "entityLink" | "hooksContentItemProvidersContent">;
  readonly " $fragmentType": "homeHeroArticleContentItemContent";
};
export type homeHeroArticleContentItemContent$key = {
  readonly " $data"?: homeHeroArticleContentItemContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"homeHeroArticleContentItemContent">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v2 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "entityLink"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "homeHeroArticleContentItemContent",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "moreOnThisArticles",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "contentHeadlineContent"
        },
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Topic",
      "kind": "LinkedField",
      "name": "topics",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "followButtonBase"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentTopicLinkContent"
    },
    (v2/*: any*/),
    {
      "args": [
        {
          "kind": "Literal",
          "name": "withActionBar",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withCoverImage",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withCoverImageSize1200x800",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withCoverImageSize540x360",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withHeadline",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withLiveTag",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withSummary",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withTopicLink",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withVideoDurationOverlay",
          "value": true
        }
      ],
      "kind": "FragmentSpread",
      "name": "hooksContentItemProvidersContent"
    }
  ],
  "type": "Article",
  "abstractKey": null
};
})();

(node as any).hash = "570402a2962a720a2d0c8d00c6523367";

export default node;
